export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.flixxo.apps.flixxoapp'
export const APPLE_STORE_URL = 'https://apps.apple.com/app/flixxo/id1447682880'

export const STATE_VERSION = '7'

export const CAPTCHA_TOKEN = '6LdbTTIiAAAAAFlvL60M0D7mxYtHztzpPXGpxovA'

export const RECAPTCHA_TYPES = {
  v2: 'recaptcha-v2',
  v3: 'recaptcha-v3',
  bypass: 'bypass',
}

export const USER_STATUS = {
  enabled: 1,
  registered: 32,
  confirmed: 2,
  active: 4,
  emailConfirmed: 8,
  smsConfirmed: 16,
  banned: 128,
  deleting: 256,
  deleted: 512
}

export const CONTENT_STATUS = {
  draft: 0x00,
  new: 0x10,
  enabled: 0x20,
  cancel: 0x30,
  paused: 0x40
}

export const ORDER = {
  asc: 'ascendent',
  desc: 'descendent'
}

export const TYPE_MODALS_DOWNLOAD = {
  empty: "empty",
  spendFlixx: "spendFlixx",
  enjoyContent: "enjoyContent"
};

export const PLAYER_ID = "my-player";


export const BITTREX_URL = 'https://global.bittrex.com/'
export const BANCOR_URL = 'https://home.bancor.network/'
export const UNISWAP_URL = 'https://uniswap.org/'
export const COINMARKETCAP_URL = 'https://coinmarketcap.com/es/currencies/flixxo/'